<template>
  <div :class="className">
    <input type="search" :value="currentSearchTerm" @input="handleInput" :placeholder="placeholder" class="add-large-bottom-margin">
  </div>
</template>

<script>

import { mapState } from 'vuex';
import { mapActions } from 'vuex';

import { GET_FILTERED_ITEMS } from '../vuex/modules/catalog/mutations';
import { GET_FILTERED_AUTHORS } from '../vuex/modules/catalog/mutations';

import _ from 'lodash';

export default {
  name: 'CatalogSearchField',
  props: ['catalog', 'className'],
  components: {
  },
  data() {
    return {
      // searchTerm: '',
      placeholder: `Search in ${this.catalog}`,

    }
  },

  methods: {
    ...mapActions({
      GET_FILTERED_ITEMS,
      GET_FILTERED_AUTHORS,
    }),

    // handles the text input on the search box at the top of the filters. It first mutates the
    // current query term, and then calls the action for the API call.
    handleInput: _.debounce(function($event){
      const searchTerm = $event.target.value;

      this.$store.commit('setPageNumber', 1);
      this.$store.commit('setSearchTerm', searchTerm);
      this.getFilteredResults();

    }, 300),

    // do the API call.
    getFilteredResults() {
      const $vm = this;

      if( this.catalog == 'authors' ){
        this.GET_FILTERED_AUTHORS()
          .then(function() {
            $vm.$store.commit('buildNextLinks', $vm.totalPages);
            $vm.$store.commit('buildPrevLinks');
          })
      }else{
        this.GET_FILTERED_ITEMS()
          .then(function() {
            // console.log('got filtered results');
            $vm.$store.commit('buildNextLinks', $vm.totalPages);
            $vm.$store.commit('buildPrevLinks');
          })
      }
    },



    // if the passed string contains either of the terms, then combine them
    // in the search API query on the inital page load.
    setQueryField(href) {
      // check for a query param
      if( this.isInUrl(href, 'keyword') ){
        return 'keyword';
      }else if( this.isInUrl(href, 'catalogId') ){
        return 'catalogId';
      }else{
        return null;
      }
    },

  },

  computed: {
    ...mapState({
      filters: state => state.catalogStore.attributes,
      currentSearchTerm: state => state.catalogStore.searchTerm,
      activeCategory: state => state.catalogStore.activeCategory,
      collections: state => state.collections,
    }),
  },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogSearchField.vue